import { render, staticRenderFns } from "./search-listing-product-item.vue?vue&type=template&id=58e6d363&"
import script from "./search-listing-product-item.vue?vue&type=script&lang=js&"
export * from "./search-listing-product-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cinderellamaecuya/SP/peppermayo-astro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e6d363')) {
      api.createRecord('58e6d363', component.options)
    } else {
      api.reload('58e6d363', component.options)
    }
    module.hot.accept("./search-listing-product-item.vue?vue&type=template&id=58e6d363&", function () {
      api.rerender('58e6d363', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/search-listing-product-item.vue"
export default component.exports